type TickerData = {
  header: string;
  value: string;
};

type TickerTotalProps = {
  tickerCombinedData: TickerData[];
  ticker: string | undefined;
};

const TickerTotal: React.FC<TickerTotalProps> = ({ tickerCombinedData, ticker }) => (
  <>
    <h2 className="pb-4 text-lg font-medium">{ticker ? `${ticker} Total` : "No ticker!"}</h2>
    <div className="flex justify-between rounded-md border border-neutral-500 bg-white p-6 shadow-light">
      {tickerCombinedData.map(({ header, value }) => (
        <div className="flex flex-col gap-4" key={header}>
          <span className="font-medium">{header}</span>
          <span>{value}</span>
        </div>
      ))}
    </div>
  </>
);

export default TickerTotal;
